import * as React from 'react';
export const IcMusical = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5 5.5a1 1 0 011 1 .5.5 0 001 0 1 1 0 011-1 .5.5 0 00.35-.85.47.47 0 00-.35-.15 1 1 0 01-1-1 .5.5 0 00-1 0 1 1 0 01-1 1 .5.5 0 00-.35.85.47.47 0 00.35.15zm-9 13a1 1 0 01-1-1 .5.5 0 00-1 0 1 1 0 01-1 1 .5.5 0 000 1 1 1 0 011 1 .5.5 0 101 0 1 1 0 011-1 .5.5 0 000-1zm12.08-8.32a1.16 1.16 0 00-.43-.18 1.06 1.06 0 00-.47 0l-3 1a1 1 0 00-.49.37.94.94 0 00-.19.63v5a2.17 2.17 0 00-.75.22 2 2 0 00-.62.49c-.166.2-.292.431-.37.68-.079.252-.11.517-.09.78.018.266.093.526.22.76a2 2 0 00.48.61c.204.169.438.297.69.38.252.081.517.108.78.08a2 2 0 001.22-.75 2.08 2.08 0 00.44-1.37v-5.17l2.32-.71a1 1 0 00.51-.38A1 1 0 0021 12v-1a.999.999 0 00-.11-.45 1.08 1.08 0 00-.31-.37zm-7-7a.93.93 0 00-.41-.2.9.9 0 00-.46 0l-7 2a1 1 0 00-.54.37A1 1 0 005 6v5a2 2 0 102 2V7.75l5-1.42V10a2 2 0 102 2V4a1 1 0 00-.11-.45.9.9 0 00-.29-.35l-.02-.02z'
      fill='currentColor'
    />
  </svg>
);
